// frontend/src/components/layout/GlassPanel.js
export default function GlassPanel({ children, style }) {
  return (
    <div
      className="glass-panel"
      style={{
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
